export const LongTopArrow = () => {
  return (
    <svg
      width="12"
      height="124"
      viewBox="0 0 12 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.77343 -7.36713e-06L-7.0135e-05 9.99999L11.5469 9.99999L5.77343 -7.36713e-06ZM5.77344 120L6.77344 120L6.77343 8.99999L5.77343 8.99999L4.77343 8.99999L4.77344 120L5.77344 120Z"
        fill="white"
      />
      <rect
        x="8.77344"
        y="118"
        width="6"
        height="6"
        rx="3"
        transform="rotate(90 8.77344 118)"
        fill="white"
      />
    </svg>
  );
};
